const ValidationType = Object.freeze({
    Info: "info",
    Error: "error",
    Warning: "warning"
});

export default ValidationType;
